import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.28",
  height: "13.28",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.64 0A6.637 6.637 0 0 0 .008 6.314a6.637 6.637 0 0 0 6.306 6.958 6.7 6.7 0 0 0 2.253-.278 6.6 6.6 0 0 0 2.028-1.02A6.63 6.63 0 0 0 13.28 6.64a6.7 6.7 0 0 0-.388-2.237 6.7 6.7 0 0 0-.731-1.452 6.7 6.7 0 0 0-1.309-1.444A6.63 6.63 0 0 0 6.64 0m0 3.32a1.34 1.34 0 0 1 .939.389 1.3 1.3 0 0 1 .311.492 1.3 1.3 0 0 1 .072.577 1.35 1.35 0 0 1-.218.608 1.326 1.326 0 0 1-1.996.246 1.3 1.3 0 0 1-.335-.476 1.32 1.32 0 0 1 .288-1.447 1.3 1.3 0 0 1 .492-.311 1.3 1.3 0 0 1 .447-.078m3.04 6.64H3.592c-.096 0-.28-.224-.272-.336a3.08 3.08 0 0 1 .698-1.86 3.1 3.1 0 0 1 1.536-1.012 3.1 3.1 0 0 1 1.078-.112c1.768 0 3.2.952 3.328 2.984a.3.3 0 0 1-.007.14.3.3 0 0 1-.097.139.3.3 0 0 1-.098.048.3.3 0 0 1-.078.009" }, null, -1)
  ])))
}
export default { render: render }